import * as Sentry from '@sentry/react'
import type { Reporter } from '@betterplace/error-reporting'

export const report: Reporter = (...args) => {
  // eslint-disable-next-line import/namespace
  Sentry.captureException(...args)
}
